/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "metadataURI",
                type: "string",
            },
        ],
        name: "OperatorMetadataURIUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "contract IStrategy[]",
                name: "strategies",
                type: "address[]",
            },
        ],
        name: "getOperatorShares",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "earningsReceiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "delegationApprover",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "stakerOptOutWindowBlocks",
                        type: "uint32",
                    },
                ],
                internalType: "struct IDelegationManager.OperatorDetails",
                name: "registeringOperatorDetails",
                type: "tuple",
            },
            {
                internalType: "string",
                name: "metadataURI",
                type: "string",
            },
        ],
        name: "registerAsOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IDelegationManager__factory {
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=IDelegationManager__factory.js.map